//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OrderCompletion",
  data() {
    return {
      orders: [],
      fileType: 3, //2合同原件 3订单原件 4结算凭证
      contractFileList: [],
      contractFilePreviewList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
    };
  },
  props: {
    contractId: {
      type: String,
    },
  },
  filters: {
    formatWorkProgress(value) {
      return `${value}%`;
    },
  },
  created() {
    this.getContractOrderList();
  },
  methods: {
    /**
     * @descripttion: 获取合同订单
     * @Author: juanjuanhui
     * @Date: 2021-11-23 14:04:06
     * @param {*}
     * @return {*}
     */
    getContractOrderList() {
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, contractId: this.contractId };
      this.$http.contract.getContractOrderList(params).then((res) => {
        let { recordTotal, content: orders } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.orders = orders;
      });
    },
    /**
     * @descripttion: 查看文件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:20:36
     * @param {*} id
     */
    handleLookFile(type, bizId) {
      let params = { type, bizId };
      this.getContractFileList(params);
    },
    /**
     * @descripttion: 获取订单原件
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getContractFileList(params) {
      this.$http.common.getContractFileList(params).then((res) => {
        let contractFileList = res.data;
        this.contractFileList = contractFileList;
        if (contractFileList.length > 0) {
          this.contractFileList.forEach((item) => {
            this.contractFilePreviewList.push(item.picPath);
          });
          this.$refs.previewImg.showViewer = true;
        } else {
          this.$message({
            message: "暂无订单原件",
            type: "success",
          });
        }
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getContractOrderList();
    },
  },
};
